// @flow
import type { DeliveryAddressActionType } from './actions';
import type { StateType } from '../../reducers';
import type { AddressType } from 'digicel-kaizen-library';

export const initialState: DeliveryAddressStateType = {
  street1: '',
  street2: '',
  postCode: '',
  city: '',
  stateOrProvince: '',
  deliveryInstruction: '',
  latitude: '',
  longitude: '',
};

export default (state: DeliveryAddressStateType = initialState, action: DeliveryAddressActionType) => {
  switch (action.type) {
    case 'SIGNUP_SET_DELIVERY_ADDRESS':
      const { deliveryAddress } = action.payload;
      return {
        ...state,
        ...deliveryAddress,
      };

    case 'SIGNUP_SET_DELIVERY_INSTRUCTION':
      const { deliveryInstruction } = action.payload;
      return {
        ...state,
        deliveryInstruction,
      };

    default:
      return state;
  }
};

type DeliveryAddressStateType = AddressType;

const deliveryAddressStateSelector = (state: StateType) => state.signUp.deliveryAddress;

export function deliveryAddressSelector(state: StateType): AddressType {
  return deliveryAddressStateSelector(state);
}

export const hasDeliveryAddressSelector = (state: StateType): boolean => {
  const deliveryAddress = deliveryAddressSelector(state);
  return (
    !!deliveryAddress.street1 &&
    !!deliveryAddress.postCode &&
    !!deliveryAddress.city &&
    !!deliveryAddress.stateOrProvince
  );
};

export function deliveryInstructionSelector(state: StateType): string {
  return deliveryAddressStateSelector(state).deliveryInstruction;
}

export function deliveryGeolocationSelector(state: StateType): ?GeolocationType {
  const { latitude, longitude } = deliveryAddressStateSelector(state);

  if (latitude === '' || longitude === '') {
    return null;
  }

  return {
    latitude,
    longitude,
  };
}

export type GeolocationType = {
  latitude: string,
  longitude: string,
};
